module.exports = __webpack_public_path__ + "static/media/cases_impressos_nec_04.f8ace1ed.jpg";